import React, { useEffect, useRef, useState } from 'react';
import './customTimePicker.css'
import { Button, Grid, List, ListItem } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Field } from 'formik';

const CustomTimePicker = ({
    minutesStep, 
    time, 
    updateTimeToParent, 
    minTime,
    minTimeDiffInMinutes = 0, 
    readOnly,
    maxHours, 
    hasInititalValues = false ,
    rtcValue,
}) => {
    const [open, setOpen] = useState(null);
    const clockList = useRef(null);
    const [hour, setHour] = useState('');
    const [minute, setMinute] = useState('');
    const [hrVisited, sethrVisited] = useState(hasInititalValues);
    const minTimeSplit = minTime?.split(':');
    let minHours = 0;
    let minMinutes = 0;
    if(minTimeSplit?.length && minTimeSplit.length>1){
        let totalTime = (parseInt(minTimeSplit[0]) * 60)+parseInt(minTimeSplit[1])+minTimeDiffInMinutes;
        minHours = Math.ceil(totalTime/60);
        minMinutes = totalTime%60;
        if(minMinutes>14){
            minHours-=1;
        }
    }
    const closeOpenMenus = (e)=>{
        if(clockList.current && open && !clockList.current.contains(e.target)){
            setOpen(false);
        }
    }
    useEffect(()=>{
        let hr = '';
        let min = '';
        if(time){
            let timeSplit = time.split(':');
            hr = ((!hrVisited && parseInt(timeSplit[0]) || hrVisited||rtcValue) && timeSplit[0]) ? timeSplit[0] : '';
            min = ((!hrVisited && parseInt(timeSplit[1]) || hrVisited||rtcValue) && timeSplit[1]) ? timeSplit[1] : '';
        }
        setHour(hr);
        setMinute(min);
    },[time]);
    useEffect(()=>{
        document.addEventListener('mousedown',closeOpenMenus);

        return ()=>{
            document.removeEventListener('mousedown',closeOpenMenus);
        }
    });
    const handleClick = (event) => {
        event.stopPropagation();
        setOpen(!open);
    };
  
    const hours = [...Array(maxHours-minHours)].map((_, index) => {
        const hour = (index + minHours).toString().padStart(2, '0');
        return {
          label: hour,
          value: hour,
        };
    });

    const minutes = [...Array(59)].map(function(_,index) {
        const minute = (index).toString().padStart(2, '0');
            return {
                label: minute,
                value: minute,
            };
    }).filter((_, index) => {
        return index % minutesStep == 0;
    });

    const getMinutesToBeAppended = (min) => {
        if(min<=15) return 15;
        if(min<=30) return 30;
        if(min<=45) return 45;
    }
    const handleHourChange = (value) => {
        let timerText = (value?value:'00')+':';
        if (value == '24' || minute == '') {
            timerText+='00';
        }else {
            let minutesToBeAppended = 0;
            if(minTime?.length && (parseInt(value) == minHours && minMinutes!=0)) {
                minutesToBeAppended = getMinutesToBeAppended(minMinutes);
                timerText+=(minutesToBeAppended).toString().padStart(2, '0');
            } else if(value !== hour) {
                timerText+='00';
            } else {
                timerText+=minute;
            }
        }
        updateTimeToParent(timerText);
        if(!hrVisited){
            sethrVisited(true);
        }
    };

    const handleMinuteChange = (value) => {
        let timerText = '';
        if (hour == '') {
            timerText +='00:'
        }else{
            timerText+=hour+':'
        }
        timerText+=(value?value:'00');
        updateTimeToParent(timerText);
    };

    const handleHourInput = (e) =>{
        let val = e.target.value;
        let hr = '0';
        if(!isNaN(val)){
            let valNumber = parseInt(val);
            if(valNumber > 24){
                hr+= val.charAt(val.length - 1);
            }else if(valNumber < 10){
                hr+=valNumber;
            }else{
                hr = valNumber;
            }
            handleHourChange(hr);
        }else if(val == ''){
            handleHourChange('');
        }
    
    }

    const handleMinuteInput = (e) =>{
        let val = e.target.value;
        let min = '0';
        if(!isNaN(val)){
            let valNumber = parseInt(val);
            if(valNumber > 60){
                min+= val.charAt(val.length - 1);
            }else if(valNumber < 10){
                min+=valNumber;
            }else{
                min = valNumber;
            }
            handleMinuteChange(min);
        }else if(val == ''){
            handleMinuteChange('');
        }
    }
    
    return <Grid container className={`time-picker-wrapper ${minHours&&(minHours > parseInt(hour) || (minHours == parseInt(hour) && minMinutes > parseInt(minute)) ) ? 'error':''} ${readOnly?'disabled':''}`}>
            <Grid item xs={2} className='grid-item'>
                <Field 
                    className="form-text-input"
                    type="text"
                    name="hour-hand"
                    value={hour || "00"}
                    onChange = {handleHourInput}
                    placeholder="HH"
                    autocomplete = "off"
                    disabled = {readOnly}
                />
            </Grid>
            <Grid item xs={1} className='grid-item'>
                <div>:</div>
            </Grid>
            <Grid item xs={2} className='grid-item'>
                <Field 
                    className="form-text-input"
                    type="text"
                    name="minute-hand"
                    value={minute || "00"}
                    onChange = {handleMinuteInput}
                    placeholder="mm"
                    autocomplete = "off"
                    disabled = {readOnly}
                />
            </Grid>
            <Grid item xs={7} ref={clockList} className="clock-wrapper grid-item">
                <AccessTimeIcon className="clock-icon" onClick = {handleClick}/>
                {open && <div className='pop-up-body'>
                    <Grid container>
                        <Grid item xs={12}>
                            <Grid container >
                                <Grid item xs={6} className='hr-wrapper'>
                                    <List className='hr-list'>
                                        {hours.map(hr=>{
                                            return <ListItem onClick = {()=>{
                                                handleHourChange(hr.value)
                                            }} className={`list-item ${hr.value == hour?'selected':''}`}>{hr.label}</ListItem>
                                        })}
                                    </List>
                                </Grid>
                                <Grid item xs={6} className='min-wrapper'>
                                    <List className='min-list'>
                                        {minutes.map(min=>{
                                            if(!((minHours == parseInt(hour) && minMinutes>parseInt(min.value)) || ((parseInt(minHours)===24 || parseInt(hour) === 24) && parseInt(min.value) !== 0))){
                                                return <ListItem  onClick = {()=>{
                                                    handleMinuteChange(min.value)
                                                }} className={`list-item ${min.value == minute?'selected':''}`}>{min.label}</ListItem>
                                            }
                                        })}
                                    </List>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} className='clock-footer'>
                            <Button variant='text' onClick={handleClick}>OK</Button>
                        </Grid>
                    </Grid>
                </div>}
            </Grid>
        </Grid>

    }

export default CustomTimePicker;
